import React, { useState, useEffect } from 'react';
import 'react-simple-keyboard/build/css/index.css';
import Styles from './simpleKeyboard.module.scss';
import KeyboardInput from '../KeyboardInput';
import cn from 'classnames';
import CustomKeyboard from '../../CustomKeyboardCopy/indexRevamp';
import { flowType } from '@utility/userInfo';
import {ReactComponent as Cross} from '@assets/images/cross.svg';
import { connect } from 'react-redux';
import { TouchableDiv } from '../../Touchable/index';

const NumberKeyboard = (props) => {
  const {
    type,
    customClass,
    placeholder,
    name,
    onChange,
    customClassInput,
    haveCurrency = false,
    value,
    isOpen,
    error,
    setError,
    isDotRequired,
    serverAppTheme,
    screenType,
    isLandScape,
  } = props;
  const [typed, setTyped] = useState('');
  const isKiosk = flowType() === 'kiosk';

  useEffect(() => {
    setTyped('');
  }, [isOpen]);

  const getStyle = () => {
    return haveCurrency === '%' ? screenType ? isLandScape ? Styles.currencyPercent : Styles.tipCurrencyPercent : Styles.currencyPercent : Styles.currencyDollar;
  };

  const onClickBtn = (e) => {
    setError && setError('');
    setTyped(e === '{bksp}' ? typed.slice(0, -1) : typed.concat(e));
    const typedValue = e === '{bksp}' ? typed.slice(0, -1) : typed.concat(e);
    onChange(typedValue);
  };

  return (
    <div>
      <div className={cn('col-12 p-1 position-relative')}>
        {haveCurrency && (
        <div
          style={{ top: '50%', transform: 'translateY(-50%)', color:  serverAppTheme? serverAppTheme.iconcolor : 'white' }}
          className={cn('position-absolute', getStyle())}
        >
          {haveCurrency}
        </div>
        )}
        <KeyboardInput
          value={value}
          name={name}
          placeholder={placeholder}
          type="text"
          customClass={customClassInput}
          serverAppTheme={serverAppTheme}
        />
        {![0, ''].includes(value) && (
          <TouchableDiv
            role="presentation"
            className="position-absolute"
            style={{ right: screenType ? isLandScape ? "10px" : "16px" : '10px', top: '50%', transform: 'translateY(-50%)' }}
            onClick={(e) => { setTyped(''); if (onChange) { onChange(''); } e.preventDefault(); }}
          > 
            <Cross fill={serverAppTheme?.iconcolor} alt='x'/>
          </TouchableDiv>
        )}
      </div>
      {error && <div className="text-right fs-12" style={{color: serverAppTheme? serverAppTheme?.error_text : '#DA1B41'}}>{error}</div>}
      <div className={`${customClass} p-1`}>
        <CustomKeyboard
          onClickBtn={(e) => onClickBtn(e)}
          type={type}
          typed={typed}
          isDot={isDotRequired}
          customClass={cn('fs-30 pl-1 pb-1', isKiosk && 'fs-40')}
          btnSize="btn35"
        />
      </div>
    </div>
  );
};

const mapStateToProps = ({theme}) => ({
  serverAppTheme: theme.serverAppTheme
})

export default connect(mapStateToProps, null)(NumberKeyboard);
